var _defs, _sodipodiNamedview;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKiwi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg54575",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    sodipodiDocname: "kiwi.svg",
    inkscapeVersion: "1.2.2 (732a01da63, 2022-12-09)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs54579"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview54577",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    showgrid: "true",
    inkscapeZoom: 16.12,
    inkscapeCx: 25,
    inkscapeCy: 25,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1009,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "g54581"
  }, /*#__PURE__*/React.createElement("inkscapeGrid", {
    type: "xygrid",
    id: "grid112343"
  }))), /*#__PURE__*/React.createElement("g", {
    inkscapeGroupmode: "layer",
    inkscapeLabel: "Image",
    id: "g54581"
  }, /*#__PURE__*/React.createElement("image", {
    width: 50,
    height: 50,
    preserveAspectRatio: "none",
    style: {},
    xlinkHref: "dataImage/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAEAAAAAAAD/7QA4UGhvdG9zaG9wIDMuMAA4 QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/8AAEQgAMgAyAwERAAIRAQMR Af/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQEC AwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNE RUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqy s7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEB AQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEH YXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZX WFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLD xMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/bAEMAAQEBAQEBAQEBAQEBAQEBAQEB AQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/bAEMBAQEBAQEB AQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEB Af/dAAQAB//aAAwDAQACEQMRAD8A/v4oAKACgAoAKACgAoA//9D+/igAoAKACgAoAKACgD//0f7+ KACgD8X/ANp//gsBoXwS+I/j74afDD4Kf8Lg1fwCdY8P3WqeI/iRd/CrQrz4j6G+pWmqeF45Ivhn 8Q9Yi0DTtYs4NEvvF/8AYtzOb8azc6L4a1vRrbQ9S8RAH6OfsuftJ/Dn9rv4F+Bv2gvhSviG38Ie Nv8AhJ9PfSPFmlR6P4p8KeL/AAF4y174c/EfwH4ktbS81bR5df8AAXxG8IeKvBOt6p4U17xP4I1n UPD91rXgjxX4u8JahofiXVAD6EoAKACgD//S/v4oA/J74u/tqeKPj18cNa/Yt/Ya0DxD8Q/E2i/8 Jp4c/aD/AGtdL0vUNQ/ZU/Zd8YeC9U8K6T4o+DXxB+LPhvxV4W1HU/j9pmneK/7b1v4D/BzxGfjs Ps2l+AdQ8S/sz2/jjW/2s/2ZgD8Nf2tv+CV3xD/YxufC/wAfvGPxn+Gf7RcnjCw0v4WeJfiXN8A/ CPwI+Nej+MdQ0oePNe0rS7D4Zm7+G2pfA7xr42074j+I/CvgDw3pfwn/AOFD6Ro/w38EXNv+0Dre s+Jfi1oYB8xfGXwB4y+Ifww8E+Cvjf4dv/iN8B/Dth4L1jwH4M8YRxeO/gPo+oa5f/F/xH4Y8T6L 4dll1n4VQ/E67vPGHxo8Oar4w+wf8LQ/4k/iz4X+JNRFt8Lv+ER8IgHr37NPj74t/s0W978W/wBn 3xBYaHpvh/xh/bHxN+HGiSX8Gj6nBrmq3l1H4o+KHgS1i03TfEng/wAYeKvG/iPSrjxjYz6hrHhj 4geITcalqXgnxZ42+G+t+LAD+sf9jD9pzQv2xf2YPhB+0bominwrP8QvD17B4z8DjULvXP8AhW/x X8Ea/rHw++NHwsPia70HwuPGB+Fnxb8K+N/h2PHGlaHYeGfGx8MHxb4TNz4Z1vRru4APqOgD/9P+ /igAoA+PP29P2bbz9rL9kr45fBXwyfD9j8Vde8AeJ7/4C+K/Eup69oejfD79oDRtF1C/+DfjrVdZ 8MWup67Z6DoPjz+xJvGOl22keIdO8XeBp/E3gfxZ4S8aeC/EviTwjrgB/AZ8Df8Ago98R/hP+0Br H7En7YPwp8Q/s1ftNeCvEOseAfGHwo8a6hLcfDPxJrfiTS/Af/CUaN4S8UaXr1pr/g4/tCaDpljp Wla34B8R/YPix8FrjQ/Dnhv46+NtD8f6JpuuAH2d+0T+2f8ACj9nj4R+Lfit4rhv/h/rE9heeErn WPD5+Fdh/wAJZpfi+wu9Z8WfD7wF4H8J/CXwVqMHjDx54wu/FUGlarpXjnT7bwv8CNRufgr4kFz8 JvDeua3QB/UP/wAERPh58Zfhl/wTK/Z70X4+/CjxD8Dvir4m8Q/tF/F/xD8JPFtxDP4p8B6f8e/2 pPjV8cvB+g+I44kivNO1+LwT8Q/Dkut6Frmn6N4p8PahPcaF4v8ADvhzxZputeHtNAP1hoA//9T+ /igAoAytWl1WHS9Sl0GzsdR1yGwvJNHsNV1O50fS7/VI7eU6dY6nrFpo/iC70jTru7WGC+1O20TW rmwgae5g0vUZ4Ft7gA/nG/4LO/8ABLf9tj/gpH8T/wBmvxr8PfBn/BPPU/DX7KfjHxfrvw60D9of 4oft1eFPFuryeNbDV7DxDq+qfEf9lvX/AIYXnh3Try78OfA7xtpHgnw74d/4S/wj8Qfhbbajp/7Q Op+Atc8W/DjxYAevf8EkP+CU/if9ivwb8PfE/wC1B8Hf2cvih+19oPjH4svrX7T2lftEftE/tCaz 4P8AB3iR/FUvgeT4B6X+0v8ADF9T+Cmo3nhXx5qfwJ+Jvh34feI/Cx8b+AfAPhHxt8QPiB8VvEet N4S8IgH74UAFAH//1f7+KACgAoAKACgAoAKAP//Z ",
    id: "image54583"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g113517"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect93711",
    width: 1,
    height: 1,
    x: 9.0114479,
    y: 30.99976
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112345",
    width: 1,
    height: 1,
    x: 10,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112347",
    width: 1,
    height: 1,
    x: 11,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112349",
    width: 1,
    height: 1,
    x: 12,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112351",
    width: 1,
    height: 1,
    x: 12,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112353",
    width: 1,
    height: 1,
    x: 13,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112355",
    width: 1,
    height: 1,
    x: 14,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112357",
    width: 1,
    height: 1,
    x: 15,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112359",
    width: 1,
    height: 1,
    x: 16,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112361",
    width: 1,
    height: 1,
    x: 16,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112363",
    width: 1,
    height: 1,
    x: 17,
    y: 26
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112365",
    width: 1,
    height: 1,
    x: 18,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112367",
    width: 1,
    height: 1,
    x: 19,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112369",
    width: 1,
    height: 1,
    x: 20,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112371",
    width: 1,
    height: 1,
    x: 22,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112373",
    width: 1,
    height: 1,
    x: 23,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112375",
    width: 1,
    height: 1,
    x: 23,
    y: 35
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112377",
    width: 1,
    height: 1,
    x: 24,
    y: 35
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112379",
    width: 1,
    height: 1,
    x: 23,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112381",
    width: 1,
    height: 1,
    x: 24,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112383",
    width: 1,
    height: 1,
    x: 25,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112385",
    width: 1,
    height: 1,
    x: 24,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112387",
    width: 1,
    height: 1,
    x: 25,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112389",
    width: 1,
    height: 1,
    x: 25,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112391",
    width: 1,
    height: 1,
    x: 26,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112393",
    width: 1,
    height: 1,
    x: 26,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112395",
    width: 1,
    height: 1,
    x: 26,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112397",
    width: 1,
    height: 1,
    x: 26,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112399",
    width: 1,
    height: 1,
    x: 27,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112401",
    width: 1,
    height: 1,
    x: 27,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112403",
    width: 1,
    height: 1,
    x: 27,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112405",
    width: 1,
    height: 1,
    x: 28,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112407",
    width: 1,
    height: 1,
    x: 28,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112409",
    width: 1,
    height: 1,
    x: 28,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112411",
    width: 1,
    height: 1,
    x: 28,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112413",
    width: 1,
    height: 1,
    x: 28,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112415",
    width: 1,
    height: 1,
    x: 29,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112417",
    width: 1,
    height: 1,
    x: 29,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112419",
    width: 1,
    height: 1,
    x: 29,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112421",
    width: 1,
    height: 1,
    x: 29,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112423",
    width: 1,
    height: 1,
    x: 29,
    y: 42
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112425",
    width: 1,
    height: 1,
    x: 29,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112427",
    width: 1,
    height: 1,
    x: 29,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112429",
    width: 1,
    height: 1,
    x: 28,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112431",
    width: 1,
    height: 1,
    x: 27,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112433",
    width: 1,
    height: 1,
    x: 30,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112435",
    width: 1,
    height: 1,
    x: 30,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112437",
    width: 1,
    height: 1,
    x: 31,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112439",
    width: 1,
    height: 1,
    x: 31,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112441",
    width: 1,
    height: 1,
    x: 32,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112443",
    width: 1,
    height: 1,
    x: 32,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112445",
    width: 1,
    height: 1,
    x: 33,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112447",
    width: 1,
    height: 1,
    x: 34,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112449",
    width: 1,
    height: 1,
    x: 33,
    y: 43
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112451",
    width: 1,
    height: 1,
    x: 33,
    y: 42
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112453",
    width: 1,
    height: 1,
    x: 33,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112455",
    width: 1,
    height: 1,
    x: 32,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112457",
    width: 1,
    height: 1,
    x: 31,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112459",
    width: 1,
    height: 1,
    x: 30,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112461",
    width: 1,
    height: 1,
    x: 30,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112463",
    width: 1,
    height: 1,
    x: 30,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112465",
    width: 1,
    height: 1,
    x: 34,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112467",
    width: 1,
    height: 1,
    x: 35,
    y: 41
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112469",
    width: 1,
    height: 1,
    x: 36,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112471",
    width: 1,
    height: 1,
    x: 37,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112473",
    width: 1,
    height: 1,
    x: 37,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112475",
    width: 1,
    height: 1,
    x: 38,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112477",
    width: 1,
    height: 1,
    x: 38,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112479",
    width: 1,
    height: 1,
    x: 39,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112481",
    width: 1,
    height: 1,
    x: 39,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112483",
    width: 1,
    height: 1,
    x: 39,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112485",
    width: 1,
    height: 1,
    x: 40,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112487",
    width: 1,
    height: 1,
    x: 40,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112489",
    width: 1,
    height: 1,
    x: 40,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112491",
    width: 1,
    height: 1,
    x: 41,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112493",
    width: 1,
    height: 1,
    x: 41,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112495",
    width: 1,
    height: 1,
    x: 41,
    y: 35
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112497",
    width: 1,
    height: 1,
    x: 41,
    y: 34
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112499",
    width: 1,
    height: 1,
    x: 41,
    y: 33
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112501",
    width: 1,
    height: 1,
    x: 41,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112503",
    width: 1,
    height: 1,
    x: 41,
    y: 31
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112505",
    width: 1,
    height: 1,
    x: 41,
    y: 30
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112507",
    width: 1,
    height: 1,
    x: 40,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112509",
    width: 1,
    height: 1,
    x: 40,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112511",
    width: 1,
    height: 1,
    x: 33,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112513",
    width: 1,
    height: 1,
    x: 31,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112515",
    width: 1,
    height: 1,
    x: 30,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112517",
    width: 1,
    height: 1,
    x: 29,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112519",
    width: 1,
    height: 1,
    x: 27,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112521",
    width: 1,
    height: 1,
    x: 25,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112523",
    width: 1,
    height: 1,
    x: 25,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112525",
    width: 1,
    height: 1,
    x: 24,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112527",
    width: 1,
    height: 1,
    x: 23,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112529",
    width: 1,
    height: 1,
    x: 20,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {},
    id: "rect112531",
    width: 1,
    height: 1,
    x: 19,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112533",
    width: 1,
    height: 1,
    x: 10,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112535",
    width: 1,
    height: 1,
    x: 11,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112537",
    width: 1,
    height: 1,
    x: 12,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112539",
    width: 1,
    height: 1,
    x: 13,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112541",
    width: 1,
    height: 1,
    x: 14,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112543",
    width: 1,
    height: 1,
    x: 15,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112545",
    width: 1,
    height: 1,
    x: 16,
    y: 24,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112547",
    width: 1,
    height: 1,
    x: 17,
    y: 24,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112549",
    width: 1,
    height: 1,
    x: 17,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112551",
    width: 1,
    height: 1,
    x: 17,
    y: 23,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112553",
    width: 1,
    height: 1,
    x: 17,
    y: 22,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112555",
    width: 1,
    height: 1,
    x: 18,
    y: 21,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112557",
    width: 1,
    height: 1,
    x: 18,
    y: 22,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112559",
    width: 1,
    height: 1,
    x: 18,
    y: 23,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112561",
    width: 1,
    height: 1,
    x: 18,
    y: 24,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112563",
    width: 1,
    height: 1,
    x: 18,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112565",
    width: 1,
    height: 1,
    x: 18,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112567",
    width: 1,
    height: 1,
    x: 19,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112569",
    width: 1,
    height: 1,
    x: 19,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112571",
    width: 1,
    height: 1,
    x: 19,
    y: 23,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112573",
    width: 1,
    height: 1,
    x: 19,
    y: 22,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112575",
    width: 1,
    height: 1,
    x: 19,
    y: 21,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112577",
    width: 1,
    height: 1,
    x: 19,
    y: 20,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112579",
    width: 1,
    height: 1,
    x: 20,
    y: 20,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112581",
    width: 1,
    height: 1,
    x: 20,
    y: 21,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112583",
    width: 1,
    height: 1,
    x: 20,
    y: 22,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112585",
    width: 1,
    height: 1,
    x: 20,
    y: 23,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112587",
    width: 1,
    height: 1,
    x: 20,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112589",
    width: 1,
    height: 1,
    x: 20,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112591",
    width: 1,
    height: 1,
    x: 20,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112593",
    width: 1,
    height: 1,
    x: 21,
    y: 20,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112595",
    width: 1,
    height: 1,
    x: 22,
    y: 20,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112597",
    width: 1,
    height: 1,
    x: 23,
    y: 21,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112599",
    width: 1,
    height: 1,
    x: 24,
    y: 22,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112601",
    width: 1,
    height: 1,
    x: 24,
    y: 23,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112603",
    width: 1,
    height: 1,
    x: 25,
    y: 24,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112605",
    width: 1,
    height: 1,
    x: 25,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112607",
    width: 1,
    height: 1,
    x: 26,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112609",
    width: 1,
    height: 1,
    x: 27,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112611",
    width: 1,
    height: 1,
    x: 28,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112613",
    width: 1,
    height: 1,
    x: 29,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112615",
    width: 1,
    height: 1,
    x: 30,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112617",
    width: 1,
    height: 1,
    x: 31,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112619",
    width: 1,
    height: 1,
    x: 32,
    y: 24,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112621",
    width: 1,
    height: 1,
    x: 34,
    y: 24,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112623",
    width: 1,
    height: 1,
    x: 35,
    y: 24,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112625",
    width: 1,
    height: 1,
    x: 35,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112627",
    width: 1,
    height: 1,
    x: 36,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112629",
    width: 1,
    height: 1,
    x: 37,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112631",
    width: 1,
    height: 1,
    x: 38,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112633",
    width: 1,
    height: 1,
    x: 39,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112635",
    width: 1,
    height: 1,
    x: 37,
    y: 44,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112637",
    width: 1,
    height: 1,
    x: 36,
    y: 44,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112639",
    width: 1,
    height: 1,
    x: 32,
    y: 42,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112641",
    width: 1,
    height: 1,
    x: 28,
    y: 44,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112643",
    width: 1,
    height: 1,
    x: 27,
    y: 44,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112645",
    width: 1,
    height: 1,
    x: 26,
    y: 44,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112647",
    width: 1,
    height: 1,
    x: 25,
    y: 44,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112649",
    width: 1,
    height: 1,
    x: 23,
    y: 44,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112651",
    width: 1,
    height: 1,
    x: 21,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112653",
    width: 1,
    height: 1,
    x: 21,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112655",
    width: 1,
    height: 1,
    x: 21,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112657",
    width: 1,
    height: 1,
    x: 21,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112659",
    width: 1,
    height: 1,
    x: 24,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112661",
    width: 1,
    height: 1,
    x: 24,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112663",
    width: 1,
    height: 1,
    x: 25,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112665",
    width: 1,
    height: 1,
    x: 25,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112667",
    width: 1,
    height: 1,
    x: 26,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112669",
    width: 1,
    height: 1,
    x: 27,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112671",
    width: 1,
    height: 1,
    x: 28,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112673",
    width: 1,
    height: 1,
    x: 29,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112675",
    width: 1,
    height: 1,
    x: 28,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112677",
    width: 1,
    height: 1,
    x: 27,
    y: 33,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112679",
    width: 1,
    height: 1,
    x: 26,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112681",
    width: 1,
    height: 1,
    x: 29,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112683",
    width: 1,
    height: 1,
    x: 28,
    y: 33,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112685",
    width: 1,
    height: 1,
    x: 29,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112687",
    width: 1,
    height: 1,
    x: 30,
    y: 33,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112689",
    width: 1,
    height: 1,
    x: 30,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112725",
    width: 1,
    height: 1,
    x: 31,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112727",
    width: 1,
    height: 1,
    x: 31,
    y: 33,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112729",
    width: 1,
    height: 1,
    x: 30,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112731",
    width: 1,
    height: 1,
    x: 31,
    y: 35,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112733",
    width: 1,
    height: 1,
    x: 32,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112735",
    width: 1,
    height: 1,
    x: 32,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112737",
    width: 1,
    height: 1,
    x: 33,
    y: 33,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112739",
    width: 1,
    height: 1,
    x: 33,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112741",
    width: 1,
    height: 1,
    x: 32,
    y: 35,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112743",
    width: 1,
    height: 1,
    x: 27,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112745",
    width: 1,
    height: 1,
    x: 34,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112747",
    width: 1,
    height: 1,
    x: 34,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112749",
    width: 1,
    height: 1,
    x: 33,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112751",
    width: 1,
    height: 1,
    x: 35,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112753",
    width: 1,
    height: 1,
    x: 35,
    y: 33,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112755",
    width: 1,
    height: 1,
    x: 35,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112757",
    width: 1,
    height: 1,
    x: 34,
    y: 35,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112759",
    width: 1,
    height: 1,
    x: 32,
    y: 36,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112761",
    width: 1,
    height: 1,
    x: 33,
    y: 36,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112763",
    width: 1,
    height: 1,
    x: 34,
    y: 36,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112765",
    width: 1,
    height: 1,
    x: 35,
    y: 36,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112767",
    width: 1,
    height: 1,
    x: 36,
    y: 36,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112769",
    width: 1,
    height: 1,
    x: 37,
    y: 36,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112771",
    width: 1,
    height: 1,
    x: 37,
    y: 35,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112773",
    width: 1,
    height: 1,
    x: 37,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112775",
    width: 1,
    height: 1,
    x: 36,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112777",
    width: 1,
    height: 1,
    x: 36,
    y: 33,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112779",
    width: 1,
    height: 1,
    x: 36,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112781",
    width: 1,
    height: 1,
    x: 37,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112783",
    width: 1,
    height: 1,
    x: 38,
    y: 33,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112785",
    width: 1,
    height: 1,
    x: 38,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112787",
    width: 1,
    height: 1,
    x: 39,
    y: 33,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112789",
    width: 1,
    height: 1,
    x: 39,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112791",
    width: 1,
    height: 1,
    x: 39,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112793",
    width: 1,
    height: 1,
    x: 38,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112795",
    width: 1,
    height: 1,
    x: 38,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112797",
    width: 1,
    height: 1,
    x: 37,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112799",
    width: 1,
    height: 1,
    x: 37,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112801",
    width: 1,
    height: 1,
    x: 36,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112803",
    width: 1,
    height: 1,
    x: 36,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112805",
    width: 1,
    height: 1,
    x: 35,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112807",
    width: 1,
    height: 1,
    x: 34,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112809",
    width: 1,
    height: 1,
    x: 34,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112811",
    width: 1,
    height: 1,
    x: 34,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112813",
    width: 1,
    height: 1,
    x: 35,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112815",
    width: 1,
    height: 1,
    x: 35,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112817",
    width: 1,
    height: 1,
    x: 36,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112819",
    width: 1,
    height: 1,
    x: 26,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112821",
    width: 1,
    height: 1,
    x: 24,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112823",
    width: 1,
    height: 1,
    x: 25,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112825",
    width: 1,
    height: 1,
    x: 26,
    y: 33,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112827",
    width: 1,
    height: 1,
    x: 28,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112829",
    width: 1,
    height: 1,
    x: 30,
    y: 35,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112831",
    width: 1,
    height: 1,
    x: 31,
    y: 36,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112833",
    width: 1,
    height: 1,
    x: 31,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112835",
    width: 1,
    height: 1,
    x: 29,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112837",
    width: 1,
    height: 1,
    x: 21,
    y: 21,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112839",
    width: 1,
    height: 1,
    x: 22,
    y: 21,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112841",
    width: 1,
    height: 1,
    x: 22,
    y: 22,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112843",
    width: 1,
    height: 1,
    x: 23,
    y: 22,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112845",
    width: 1,
    height: 1,
    x: 21,
    y: 22,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112847",
    width: 1,
    height: 1,
    x: 21,
    y: 23,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112849",
    width: 1,
    height: 1,
    x: 22,
    y: 23,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112851",
    width: 1,
    height: 1,
    x: 23,
    y: 23,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112853",
    width: 1,
    height: 1,
    x: 23,
    y: 24,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112855",
    width: 1,
    height: 1,
    x: 24,
    y: 24,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112857",
    width: 1,
    height: 1,
    x: 22,
    y: 24,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112859",
    width: 1,
    height: 1,
    x: 21,
    y: 24,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112861",
    width: 1,
    height: 1,
    x: 21,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112863",
    width: 1,
    height: 1,
    x: 22,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112865",
    width: 1,
    height: 1,
    x: 23,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112867",
    width: 1,
    height: 1,
    x: 24,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112869",
    width: 1,
    height: 1,
    x: 24,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112871",
    width: 1,
    height: 1,
    x: 25,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112873",
    width: 1,
    height: 1,
    x: 23,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112875",
    width: 1,
    height: 1,
    x: 22,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112877",
    width: 1,
    height: 1,
    x: 21,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112879",
    width: 1,
    height: 1,
    x: 21,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112881",
    width: 1,
    height: 1,
    x: 21,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112883",
    width: 1,
    height: 1,
    x: 22,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112885",
    width: 1,
    height: 1,
    x: 22,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112887",
    width: 1,
    height: 1,
    x: 22,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112889",
    width: 1,
    height: 1,
    x: 22,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112891",
    width: 1,
    height: 1,
    x: 22,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112893",
    width: 1,
    height: 1,
    x: 22,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112895",
    width: 1,
    height: 1,
    x: 23,
    y: 33,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112897",
    width: 1,
    height: 1,
    x: 23,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112899",
    width: 1,
    height: 1,
    x: 23,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112901",
    width: 1,
    height: 1,
    x: 23,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112903",
    width: 1,
    height: 1,
    x: 23,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112905",
    width: 1,
    height: 1,
    x: 23,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112907",
    width: 1,
    height: 1,
    x: 23,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112909",
    width: 1,
    height: 1,
    x: 24,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112911",
    width: 1,
    height: 1,
    x: 24,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112913",
    width: 1,
    height: 1,
    x: 25,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112915",
    width: 1,
    height: 1,
    x: 25,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112917",
    width: 1,
    height: 1,
    x: 26,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112919",
    width: 1,
    height: 1,
    x: 26,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112921",
    width: 1,
    height: 1,
    x: 27,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112923",
    width: 1,
    height: 1,
    x: 27,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112925",
    width: 1,
    height: 1,
    x: 27,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112927",
    width: 1,
    height: 1,
    x: 28,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112929",
    width: 1,
    height: 1,
    x: 28,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112931",
    width: 1,
    height: 1,
    x: 28,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112933",
    width: 1,
    height: 1,
    x: 28,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112935",
    width: 1,
    height: 1,
    x: 29,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112937",
    width: 1,
    height: 1,
    x: 29,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112939",
    width: 1,
    height: 1,
    x: 29,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112941",
    width: 1,
    height: 1,
    x: 29,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112943",
    width: 1,
    height: 1,
    x: 30,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112945",
    width: 1,
    height: 1,
    x: 30,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112947",
    width: 1,
    height: 1,
    x: 30,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112949",
    width: 1,
    height: 1,
    x: 30,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112951",
    width: 1,
    height: 1,
    x: 30,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112953",
    width: 1,
    height: 1,
    x: 31,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112955",
    width: 1,
    height: 1,
    x: 32,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112957",
    width: 1,
    height: 1,
    x: 33,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112959",
    width: 1,
    height: 1,
    x: 34,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112961",
    width: 1,
    height: 1,
    x: 33,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112963",
    width: 1,
    height: 1,
    x: 32,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112965",
    width: 1,
    height: 1,
    x: 33,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112967",
    width: 1,
    height: 1,
    x: 32,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112969",
    width: 1,
    height: 1,
    x: 31,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112971",
    width: 1,
    height: 1,
    x: 31,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112973",
    width: 1,
    height: 1,
    x: 32,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112975",
    width: 1,
    height: 1,
    x: 33,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112977",
    width: 1,
    height: 1,
    x: 31,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112979",
    width: 1,
    height: 1,
    x: 31,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112981",
    width: 1,
    height: 1,
    x: 32,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112983",
    width: 1,
    height: 1,
    x: 32,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112985",
    width: 1,
    height: 1,
    x: 32,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112987",
    width: 1,
    height: 1,
    x: 33,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112989",
    width: 1,
    height: 1,
    x: 33,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112991",
    width: 1,
    height: 1,
    x: 33,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112993",
    width: 1,
    height: 1,
    x: 34,
    y: 25,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112995",
    width: 1,
    height: 1,
    x: 34,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112997",
    width: 1,
    height: 1,
    x: 34,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect112999",
    width: 1,
    height: 1,
    x: 35,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113001",
    width: 1,
    height: 1,
    x: 35,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113003",
    width: 1,
    height: 1,
    x: 36,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113005",
    width: 1,
    height: 1,
    x: 36,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113007",
    width: 1,
    height: 1,
    x: 37,
    y: 26,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113009",
    width: 1,
    height: 1,
    x: 37,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113011",
    width: 1,
    height: 1,
    x: 38,
    y: 27,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113013",
    width: 1,
    height: 1,
    x: 37,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113015",
    width: 1,
    height: 1,
    x: 38,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113017",
    width: 1,
    height: 1,
    x: 38,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113019",
    width: 1,
    height: 1,
    x: 39,
    y: 28,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113021",
    width: 1,
    height: 1,
    x: 39,
    y: 29,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113023",
    width: 1,
    height: 1,
    x: 39,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113025",
    width: 1,
    height: 1,
    x: 40,
    y: 30,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113027",
    width: 1,
    height: 1,
    x: 40,
    y: 31,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113029",
    width: 1,
    height: 1,
    x: 40,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113031",
    width: 1,
    height: 1,
    x: 40,
    y: 33,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113033",
    width: 1,
    height: 1,
    x: 40,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113035",
    width: 1,
    height: 1,
    x: 40,
    y: 35,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113037",
    width: 1,
    height: 1,
    x: 39,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113039",
    width: 1,
    height: 1,
    x: 39,
    y: 35,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113041",
    width: 1,
    height: 1,
    x: 38,
    y: 35,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113043",
    width: 1,
    height: 1,
    x: 39,
    y: 36,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113045",
    width: 1,
    height: 1,
    x: 38,
    y: 36,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113047",
    width: 1,
    height: 1,
    x: 38,
    y: 37,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113049",
    width: 1,
    height: 1,
    x: 37,
    y: 37,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113051",
    width: 1,
    height: 1,
    x: 37,
    y: 38,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113053",
    width: 1,
    height: 1,
    x: 36,
    y: 38,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113055",
    width: 1,
    height: 1,
    x: 36,
    y: 39,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113057",
    width: 1,
    height: 1,
    x: 35,
    y: 39,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113059",
    width: 1,
    height: 1,
    x: 35,
    y: 40,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113061",
    width: 1,
    height: 1,
    x: 34,
    y: 40,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113063",
    width: 1,
    height: 1,
    x: 33,
    y: 40,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113065",
    width: 1,
    height: 1,
    x: 32,
    y: 40,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113067",
    width: 1,
    height: 1,
    x: 31,
    y: 40,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113069",
    width: 1,
    height: 1,
    x: 31,
    y: 39,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113071",
    width: 1,
    height: 1,
    x: 30,
    y: 38,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113073",
    width: 1,
    height: 1,
    x: 29,
    y: 37,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113075",
    width: 1,
    height: 1,
    x: 28,
    y: 36,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113077",
    width: 1,
    height: 1,
    x: 27,
    y: 36,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113079",
    width: 1,
    height: 1,
    x: 26,
    y: 35,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113081",
    width: 1,
    height: 1,
    x: 25,
    y: 35,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113083",
    width: 1,
    height: 1,
    x: 24,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113085",
    width: 1,
    height: 1,
    x: 24,
    y: 32,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113087",
    width: 1,
    height: 1,
    x: 24,
    y: 33,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113089",
    width: 1,
    height: 1,
    x: 25,
    y: 33,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113091",
    width: 1,
    height: 1,
    x: 25,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113093",
    width: 1,
    height: 1,
    x: 26,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113095",
    width: 1,
    height: 1,
    x: 27,
    y: 34,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113097",
    width: 1,
    height: 1,
    x: 27,
    y: 35,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113099",
    width: 1,
    height: 1,
    x: 28,
    y: 35,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113101",
    width: 1,
    height: 1,
    x: 29,
    y: 35,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113103",
    width: 1,
    height: 1,
    x: 29,
    y: 36,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113105",
    width: 1,
    height: 1,
    x: 30,
    y: 36,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113107",
    width: 1,
    height: 1,
    x: 30,
    y: 37,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113109",
    width: 1,
    height: 1,
    x: 31,
    y: 38,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113111",
    width: 1,
    height: 1,
    x: 32,
    y: 39,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113113",
    width: 1,
    height: 1,
    x: 33,
    y: 39,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113115",
    width: 1,
    height: 1,
    x: 34,
    y: 39,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113117",
    width: 1,
    height: 1,
    x: 36,
    y: 37,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113119",
    width: 1,
    height: 1,
    x: 34,
    y: 38,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113121",
    width: 1,
    height: 1,
    x: 35,
    y: 38,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113123",
    width: 1,
    height: 1,
    x: 33,
    y: 37,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113125",
    width: 1,
    height: 1,
    x: 35,
    y: 37,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113127",
    width: 1,
    height: 1,
    x: 34,
    y: 37,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113129",
    width: 1,
    height: 1,
    x: 33,
    y: 38,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113131",
    width: 1,
    height: 1,
    x: 32,
    y: 38,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113133",
    width: 1,
    height: 1,
    x: 32,
    y: 37,
    inkscapeLabel: "rect112533"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.5
    },
    id: "rect113135",
    width: 1,
    height: 1,
    x: 31,
    y: 37,
    inkscapeLabel: "rect112533"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiwi);
export default __webpack_public_path__ + "static/media/kiwi.a295fe3a2a91067c369818ea88263698.svg";
export { ForwardRef as ReactComponent };